export enum SelectorIdentifier {

    MonitorSeriesOptions = 'monitorSeriesOptions',
    CommunicationTypes = 'communicationTypes',
    LocationStatuses = 'locationStatuses',
    LocationStatusesWithNoMaintenance = 'locationStatusesWithNoMaintenance',
    SampleRates = 'sampleRates',
    ScanRates = 'scanRates',
    FlexSampleRates = 'flexSampleRates',
    DataDeliveryNormalRate = 'dataDeliveryNormalRate',
    DataDeliveryFastRate = 'dataDeliveryFastRate',
    ForeSiteSampleRates = 'foreSiteSampleRates',
    ForeSiteNormalDeliveryList = 'foreSiteNormalDeliveryList',
    FlexDataDeliveryNormalRateList = 'flexDataDeliveryNormalRateList',
    FlexDataDeliveryFastRateList = 'flexDataDeliveryFastRateList',
    MaintenanceIntervals = 'maintenanceIntervals',
    InstallationTypes = 'installationTypes',
    FlexInstallationTypes = 'flexInstallationTypes',
    ModemProviders = 'modemProviders',
    RainGauges = 'rainGauges',
    QFinalEntities = 'qFinalEntities',

    FlowLossAlarmTypes = 'flowLossAlarmTypes',
    FlowLossSensitivity = 'flowLossSensitivity',
    FlowLossPercentange = 'flowLossPercentange',

    // Adding sensor selectors
    PrimarySensors = 'primarySensors',
    SecondarySensors = 'secondarySensors',
    MonitoringPoints = 'monitoringPoints',
    Channels = 'channels',

    DepthSensorPreferencesCh1 = 'depthSensorPreferencesCh1',
    VelocitySensorPreferencesCh1 = 'velocitySensorPreferencesCh1',
    DepthSensorPreferencesCh2 = 'depthSensorPreferencesCh2',
    VelocitySensorPreferencesCh2 = 'velocitySensorPreferencesCh2',
    TemperatureSensors = 'temperatureSensors',
    ComPorts = 'comPorts',

    // Flow section selectors
    FlowParamsMp1 = 'flowParamsMp1',
    FlowParamsMp2 = 'flowParamsMp2',

    // Sampler selectors
    SamplerTypes = 'samplerTypes',
    SamplerPerWakeupOptions = 'samplerPerWakeupOptions',
    SamplerPulseLengthOptions = 'samplerPulseLengthOptions',

    // AV|Gated sensor selectors
    FlowTypes = 'flowTypes',
    DeadBandList = 'deadBandList',
    DirectionList = 'directionList',
    DirectionListTwoDirectional = 'directionListTwoDirectional',
    MinVelocityList = 'minVelocityList',
    MaxVelocity = 'maxVelocity',
    VelocityAcquisition = 'velocityAcquisition',

    // Peak combo sensor selectors
    SensitivityList = 'sensitivityList',
    TransmitFrequencyList = 'transmitFrequencyList',

    // Long Range Depth Triton specific selectors
    SensorTemp = 'sensorTemp',
    SensorPower = 'sensorPower',
    EchoSensorPower = 'echoSensorPower',
    GainControlOptions = 'gainControlOptions',
    GainValues = 'gainValues',

    // Smart Depth sensor selectors
    ModeList = 'modeList',
    BlankingList = 'blankingList',

    // Surface Combo specific selectors
    SVTransmitFrequencyList = 'svTransmitFrequencyList',
    SVDirectionList = 'svDirectionList',
    PVDirectionList = 'pvDirectionList',
    SVDurationList = 'svDurationList',
    SurfaceMaxVelocity = 'surfaceMaxVelocity',

    // Foresite data delivery
    FastModeOptions = 'fastModeOptions',

    // Echo specific selectors
    EchoInfoSensorOptions = 'echoInfoSensorOptions',

    // Rain specific selectors
    BatteryVoltageOptions = 'batteryVoltageOptions',
    RainSensorOptions = 'rainSensorOptions',
    DataLogModeOptions = 'dataLogModeOptions',

    // Foresite XD specific selectors
    ForeSiteXdSensorOptions = 'foreSiteXdSensorOptions',

    // Autocompletes
    RainGaugeAutocomplete = 'rainGaugeAutocomplete',
    TagKeyAutocomplete = 'tagKeyAutocomplete',

    // Dynamic sections
    DynamicSections = 'dynamicSections',
    DynamicSectionsMp2 = 'dynamicSectionsMp2',

    FlexFlowType = 'flexFlowType',

    Mp1DepthEntityTypes = 'mp1DepthEntityTypes',
    Mp1VelocityEntityTypes = 'mp1VelocityEntityTypes',
    Mp2DepthEntityTypes = 'mp2DepthEntityTypes',
    Mp2VelocityEntityTypes = 'mp2VelocityEntityTypes',

    // Advanced section selectors
    CheckInHourOptions = 'checkInHourOptions',
}
